export const DISCHARGE_STEPS_RECEIVED = "DISCHARGE_STEPS_RECEIVED";
export const DISCHARGE_PROGRESS_RECEIVED = "DISCHARGE_PROGRESS_RECEIVED";
export const DISCHARGE_STEPS_FAILURE = "DISCHARGE_STEPS_FAILURE";
export const DISCHARGE_PROGRESS_FAILURE = "DISCHARGE_PROGRESS_FAILURE";
